/**
 * Deficnión de funcion debounce
 *
 * @param func callback para ejecución
 * @param delay tiempo de espera para la ejecución del callback
 * @param immediatee estado de ejecución de ejecucion inmediato
 */
export const debounce: Debounce<(e: Event) => Promise<void> | void> = (func, delay, immediate) => {
  let timeout: ReturnType<typeof setTimeout> | null = null;

  return function(this: ThisParameterType<typeof func>, ...args: Parameters<typeof func>) {
    const callNow = immediate && !timeout;

    if (timeout) clearTimeout(timeout);

    timeout = setTimeout(() => {
      timeout = null;
      if (!immediate) func.apply(this, args);
    }, delay);

    if (callNow) func.apply(this, args);
  };
};

/**
 * Definición de Debounce
 */
type Debounce<T extends (...args: any[]) => void> = (
  func: T,
  delay: number,
  inmmediate?: boolean
) => (...args: Parameters<T>) => void
